import React from 'react';
import { Link } from 'react-router-dom';

const ContactMini = () => (
  <section className="py-12 bg-white/90">
    <div className="container mx-auto px-4 max-w-2xl text-center rounded-2xl border border-[#B38053]/10">
      <h2 className="text-3xl font-bold text-[#B38053] mb-4">Contact Us</h2>
      <p className="text-gray-700 mb-6">
        Have a question, custom request, or want to collaborate? We'd love to hear from you!
      </p>
      <div className="mb-6 space-y-1">
        <p className="text-gray-800"><span className="font-semibold">Email:</span> <span className="text-[#B38053]">anggood.info@gmail.com</span></p>
        <p className="text-gray-800"><span className="font-semibold">Phone:</span> <span className="text-[#B38053]">+91 9694444893</span></p>
      </div>
      <Link to="/contact">
        <button className="btn btn-primary bg-[#B38053] text-white px-6 py-2 rounded hover:bg-[#96643c] transition-colors">
          Go to Contact Page
        </button>
      </Link>
    </div>
  </section>
);

export default ContactMini; 